/* eslint-disable no-unused-vars */
import {HyperlinkTarget} from './enum';
import {Stage} from './stage';
import {Team} from './team';

/**
 * Situação da partida
 */
export enum MatchStatus {
  SCHEDULED = 'SCHEDULED',
  FINISHED = 'FINISHED',
  RUNNING = 'RUNNING',
  POSTPONED = 'POSTPONED',
  CANCELED = 'CANCELED',
  SUSPENDED = 'SUSPENDED',
  DELETED = 'DELETED',
  DRAFT = 'DRAFT',
}

/**
 * Formato dos confrontos na geração automática de jogos
 * (POST /api/v1/competitions/matches/generate).
 */
export enum MatchScheduleFormat {
  SINGLE_LEG = 'SINGLE_LEG', // Turno único
  DOUBLE_LEG = 'DOUBLE_LEG', // Turno e returno (ida e volta)
}

export type MatchV2 = {
  uuid: string;
  home_team_uuid: string;
  home_team: Team;
  away_team_uuid: string;
  away_team: Team;
  match_date?: string;
  transmission?: string;
  stadium?: string;
  hyperlink?: string;
  hyperlink_target?: HyperlinkTarget;
  description?: string;
  round: number;
  home_goals?: number;
  away_goals?: number;
  extra_time_home?: number;
  extra_time_away?: number;
  penalties_home?: number;
  penalties_away?: number;
  status: MatchStatus;
  is_show_information?: boolean;
  is_last_matches?: boolean;
  last_matches?: {
    home_goals: number;
    away_goals: number;
    home_team_uuid: string;
    home_team_name: string;
    away_team_uuid: string;
    away_team_name: string;
  }[];
  is_history_matches?: boolean;
  history_matches?: {
    wins: number;
    draw: number;
    lose: number;
  };
  created_at: string;
  updated_at: string;
  stage?: Stage;
};
